// extracted by mini-css-extract-plugin
export default {"header":"feesAch_header__KqvHg"};